import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SearchHome(props) {
  return (
    <Svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
      <Path
        d="M15.269 13.144l-.095.137.118.118 4.122 4.122c.259.259.386.569.386.94v0c0 .362-.13.673-.398.94h0a1.278 1.278 0 01-.94.399c-.38 0-.687-.131-.937-.394h0l-.003-.004-4.123-4.11-.118-.119-.137.095c-1.4.97-2.96 1.455-4.682 1.455a8.115 8.115 0 01-3.21-.65 8.261 8.261 0 01-2.64-1.761h0a8.258 8.258 0 01-1.76-2.641A8.115 8.115 0 01.2 8.46c0-1.118.217-2.187.651-3.208a8.26 8.26 0 011.76-2.642h0A8.258 8.258 0 015.253.851h0A8.114 8.114 0 018.462.2C9.58.2 10.65.417 11.67.851a8.26 8.26 0 012.64 1.76 8.256 8.256 0 011.761 2.642h0c.434 1.02.652 2.09.652 3.209 0 1.722-.485 3.281-1.455 4.682zM18.462 20c.416 0 .777-.152 1.082-.457H17.38c.289.305.649.457 1.082.457zm-10-5.954c1.536 0 2.854-.548 3.945-1.639h0c1.091-1.091 1.64-2.41 1.64-3.945 0-1.536-.549-2.855-1.64-3.946-1.09-1.09-2.41-1.64-3.945-1.64-1.536 0-2.855.549-3.946 1.64-1.09 1.091-1.639 2.41-1.639 3.946 0 1.535.548 2.854 1.64 3.945 1.09 1.09 2.409 1.64 3.945 1.64z"
        fill="#222323"
        stroke="#fff"
        strokeWidth={0.4}
      />
    </Svg>
  );
}

export default SearchHome;
